import React from "react";

export class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Smart-in Retail crashed:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="grid min-h-[100dvh] place-items-center bg-slate-950 px-6 text-center" data-testid="app-error">
        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-amber-400">Smart-in Retail</div>
          <h1 className="mt-4 font-display text-2xl font-bold text-white">Something went wrong</h1>
          <p className="mt-2 text-sm text-slate-400">Reload the page to continue. Your saved data is safe.</p>
          <button onClick={() => window.location.reload()} data-testid="app-error-reload" className="mt-6 h-11 rounded-full bg-amber-500 px-6 text-sm font-bold text-slate-950 hover:bg-amber-400">Reload</button>
        </div>
      </div>
    );
  }
}
